/** @format */

import React from 'react'

class Privacypolicy extends React.Component {
	render() {
		return (
			<>
				<h1>privacy_policy</h1>
				<nav
					className='navbar navbar-expand-lg bg-dark navbar-light d-none d-lg-block '
					id='templatemo_nav_top'>
					<div className='container text-light'>
						<div className='w-100 d-flex justify-content-between'>
							<div>
								<i className='fa fa-envelope mx-2'></i>
								<a
									className='navbar-sm-brand text-light text-decoration-none'
									href='mailto:SabZ@gmail.com'>
									SabZ@gmail.com
								</a>
								<i className='fa fa-phone mx-2'></i>
								<a
									className='navbar-sm-brand text-light text-decoration-none'
									href='tel:+91 7382200558 '>
									+91 7382200558
								</a>
							</div>
							<div>
								<a
									className='text-light'
									href='https://fb.com/templatemo'
									rel='noreferrer noopener sponsored'
									target='_blank'>
									<i className='fab fa-facebook-f fa-sm fa-fw me-2'></i>
								</a>
								<a
									className='text-light'
									href='https://www.instagram.com/'
									rel='noreferrer noopener sponsored'
									target='_blank'>
									<i className='fab fa-instagram fa-sm fa-fw me-2'></i>
								</a>
								<a
									className='text-light'
									href='https://twitter.com/'
									rel='noreferrer noopener sponsored'
									target='_blank'>
									<i className='fab fa-twitter fa-sm fa-fw me-2'></i>
								</a>
								<a
									className='text-light'
									href='https://www.linkedin.com/'
									rel='noreferrer noopener sponsored'
									target='_blank'>
									<i className='fab fa-linkedin fa-sm fa-fw'></i>
								</a>
							</div>
						</div>
					</div>
				</nav>

				{/* <!-- Close Top Nav -->


    <style>
        .text-align{
            text-align:justify;
        }
    </style> */}

				<div className='container'>
					<div className='row'>
						<div className='col-lg-12 mb-0 d-flex align-items-center'>
							<div className='text-align align-self-center'>
								<h3 className='h2 text-success text-align'>
									{' '}
									<b>Privacy policy:</b>{' '}
								</h3>
								<p>
									SabZ Agri Services Private Limited Privacy Policy
									<br />
									This Privacy Policy describes how your personal information is
									collected, used, and shared when you visit or make a purchase
									from www.sabzonline.in (the “Site”).
									<br />
									<br />
									<li>
										<b>PERSONAL INFORMATION WE COLLECT</b>
									</li>
									When you visit the Site, we automatically collect certain
									information about your device, including information about your
									web browser, IP address, time zone, and some of the cookies that
									are installed on your device. Additionally, as you browse the
									Site, we collect information about the individual web pages or
									products that you view, what websites or search terms referred
									you to the Site, and information about how you interact with the
									Site. We refer to this automatically-collected information as
									“Device Information.”
									<br />
									We collect Device Information using the following technologies:
									<br />- “Cookies” are data files that are placed on your device
									or computer and often include an anonymous unique identifier.
									For more information about cookies, and how to disable cookies,
									visit http://www.allaboutcookies.org.
									<br /> - “Log files” track actions occurring on the Site, and
									collect data including your IP address, browser type, Internet
									service provider, referring/exit pages, and date/time stamps.
									<br />- “Web beacons,” “tags,” and “pixels” are electronic files
									used to record information about how you browse the Site.
									<br />
									Additionally when you make a purchase or attempt to make a
									purchase through the Site, we collect certain information from
									you, including your name, billing address, shipping address,
									payment information (including credit card numbers, Debit card
									numbers, UPI ID etc), email address, and phone number. We refer
									to this information as “Order Information.”
									<br />
									When we talk about “Personal Information” in this Privacy
									Policy, we are talking both about Device Information and Order
									Information.
									<br />
									<br />
									<li>
										<b>HOW DO WE USE YOUR PERSONAL INFORMATION?</b>
									</li>
									We use the Order Information that we collect generally to
									fulfill any orders placed through the Site (including processing
									your payment information, arranging for shipping, and providing
									you with invoices and/or order confirmations). Additionally, we
									use this Order Information to: Communicate with you;Screen our
									orders for potential risk or fraud; and When in line with the
									preferences you have shared with us, provide you with
									information or advertising relating to our products or services.
									We use the Device Information that we collect to help us screen
									for potential risk and fraud (in particular, your IP address),
									and more generally to improve and optimize our Site (for
									example, by generating analytics about how our customers browse
									and interact with the Site, and to assess the success of our
									marketing and advertising campaigns).
									<br />
									We share your Personal Information with third parties to help us
									use your Personal Information, as described above. For example,
									we use Google Analytics to help us understand how our customers
									use the Site--you can read more about how Google uses your
									Personal Information here:
									https://www.google.com/intl/en/policies/privacy/. You can also
									opt-out of Google Analytics here:
									https://tools.google.com/dlpage/gaoptout.
									<br />
									Finally, we may also share your Personal Information to comply
									with applicable laws and regulations, to respond to a subpoena,
									search warrant or other lawful request for information we
									receive, or to otherwise protect our rights.
									<br />
									<br />
									<li>
										<b>BEHAVIOURAL ADVERTISING</b>
									</li>
									As described above, we use your Personal Information to provide
									you with targeted advertisements or marketing communications we
									believe may be of interest to you. For more information about
									how targeted advertising works, you can visit the Network
									Advertising Initiative’s (“NAI”) educational page at
									<br />
									http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work.
									<br />
									You can opt out of targeted advertising by:
									<br />
									FACEBOOK - https://www.facebook.com/settings/?tab=ads
									<br />
									GOOGLE - https://www.google.com/settings/ads/anonymous
									<br />
									BING -
									https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads
									<br />
									Additionally, you can opt out of some of these services by
									visiting the Digital Advertising Alliance’s opt-out portal at:
									http://optout.aboutads.info/.
									<br />
									<br />
									<li>
										<b>DO NOT TRACK</b>
									</li>
									Please note that we do not alter our Site’s data collection and
									use practices when we see a Do Not Track signal from your
									browser.
									<br />
									<br />
									<li>
										<b>YOUR RIGHTS</b>
									</li>
									If you are a European resident, you have the right to access
									personal information we hold about you and to ask that your
									personal information be corrected, updated, or deleted. If you
									would like to exercise this right, please contact us through the
									contact information below.Additionally, if you are a European
									resident we note that we are processing your information in
									order to fulfill contracts we might have with you (for example
									if you make an order through the Site), or otherwise to pursue
									our legitimate business interests listed above. Additionally,
									please note that your information will be transferred outside of
									Europe, including to Canada and the United States.
									<br />
									<br />
									<li>
										<b>DATA RETENTION</b>
									</li>
									When you place an order through the Site, we will maintain your
									Order Information for our records unless and until you ask us to
									delete this information.
									<br />
									<br />
									<li>
										<b>MINORS</b>
									</li>
									The Site is not intended for individuals under the age of 16.
									<br />
									<br />
									<li>
										<b>CHANGES</b>
									</li>
									We may update this privacy policy from time to time in order to
									reflect, for example, changes to our practices or for other
									operational, legal or regulatory reasons.CONTACT US For more
									information about our privacy practices, if you have questions,
									or if you would like to make a complaint, please contact us by
									e-mail at director@sabzonline.in or by mail using the details
									provided below:
									<br />
									<br />
									Plot No. 351, Teachers colony, Saroor Nagar, Hyderabad,
									Rangareddy, Telangana, India, Hyderabad, TG, 500035, India
								</p>
							</div>
						</div>
					</div>
				</div>

				
			</>
		)
	}
}
export default Privacypolicy
